import { logger } from '~entities/logger';

import { createMakeRequest } from '@breezeventures/web-lib-ph-request/make-request';

export const makeRequest = createMakeRequest({
  logger,
  loggerName: 'client-api',
});
